module.exports = __webpack_public_path__ + "media/images/brand/150/MARQUESBRANDINGCO LOGO ORIGINAL-46086fc78ce7f26d8546d249a6cd651e.png";